<template>
  <div class="experience--provider-description">
    <p class="experiencie--provider-operated">{{
      $t(`${base}.operated_by`)
    }}</p>
    <h2 class="experience--provider-name">{{
      $t(`${base}.name_team`, { name: exLocal.name })
    }}</h2>
    <p class="experience--provider-text">{{ exLocal.description }}</p>

    <LadProviderContact
      v-if="email || phone"
      :email="email"
      :phone="phone"
      :base="base"
      class="experience--provider-text"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadProviderDescription',
  components: {
    LadProviderContact: () =>
      import(
        /* webpackChunkName: "lad-provider-contact" */ '@/components/provider/contact'
      ),
  },
  props: {
    email: { type: String, default: null },
    phone: { type: String, default: null },
  },
  data() {
    return {
      base: 'experience.provider',
    }
  },
  computed: {
    ...mapState('experience', {
      exLocal: (state) => state.local,
    }),
  },
}
</script>

<style lang="scss">
.experience--provider-description {
  .experience--provider-text,
  .experience--provider-contact {
    @media screen and (max-width: 600px) {
      display: none;
    }
  }
}
</style>
